import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthToken } from 'src/app/models/authToken';
import { MessageService } from 'src/app/services/message.service';
import { AdminService } from '../admin.service';

@Component({
  selector: 'oap-home-support-sujet',
  templateUrl: './home-support-sujet.component.html',
  styleUrls: ['./home-support-sujet.component.scss']
})
export class HomeSupportSujetComponent implements OnInit {
  navLinks: any[];
  activeLinkIndex = -1; 

  constructor(private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private adminService: AdminService) {

    this.navLinks = [
        {
            label: 'Sujet mode connecté',
            link: 'support-sujet-connected',
            index: 0,
            typeSupportSujet: 'connected'
        }, {
          label: 'Sujet mode non connecté',
            link: 'support-sujet-not-connected',
            index: 1,
            typeSupportSujet: 'not-connected'
        }
    ];
  }

  ngOnInit(): void {
    this.messageService.sendMessage('home-support-sujet');

    this.router.events.subscribe((res) => {
        this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
    });

    this.router.navigate([this.navLinks[0].link], 
        {
            relativeTo:this.route, 
            queryParams: { typeSupportSujet: this.navLinks[0].typeSupportSujet }
        });
  }
}
